module.exports = __webpack_public_path__ + "img/cycle-2.2ab8dafc.jpg";